// extracted by mini-css-extract-plugin
export default {"wrapper":"TextInputControl_wrapper__Nizfn"};